// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Fileupload_fileUploadContainer__32eyK {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
    background: #f9fafb;
    border-radius: 8px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
  }
  
  .Fileupload_header__uWziG {
    font-weight: bold !important;
    margin-bottom: 5px !important;
    color: #333 !important;
  }
  
  .Fileupload_subHeader__0cCym {
    color: #616161;
    margin-bottom: 20px;
    font-weight: bold;
  }
  
  .Fileupload_dropzone__poHB1 {
    width: 100%;
    height: 150px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px dashed #9e9e9e;
    border-radius: 8px;
    background: #ffffff;
    margin-bottom: 20px;
    transition: background 0.3s ease, border-color 0.3s ease;
  }
  
  .Fileupload_dropzoneText__FcnwR {
    color: #757575;
  }
  
  .Fileupload_activeDropzone__CNYdz {
    background: #e3f2fd;
    border-color: #42a5f5;
  }
  
  .Fileupload_actionButtons__7i0Vr {
    margin-bottom: 20px;
  }
  
  .Fileupload_fileList__nLpsj {
    width: 100%;
  }
  
  .Fileupload_fileListItem__DoMn7 {
    display: flex;
    align-items: center;
    padding: 10px;
    margin-bottom: 10px;
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  }
  
  .Fileupload_progressBar__m0Pnf {
    flex-grow: 1;
    margin-left: 10px;
    margin-right: 10px;
  }

  .Fileupload_selectButton__owHs8{
    text-transform: none !important;
  }

  .Fileupload_selectButton__owHs8:hover{
    background-color: #49494b;
    color: #fff;
    cursor: pointer;
  }
  
  .Fileupload_deleteButton__mmnPu {
    color: #d32f2f;
  }
  
  .Fileupload_errorText__FD7nm {
    margin-top: 10px;
    font-weight: bold;
  }
  `, "",{"version":3,"sources":["webpack://./src/component/dashboard/chat/codeofconduct/Fileupload.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,0CAA0C;EAC5C;;EAEA;IACE,4BAA4B;IAC5B,6BAA6B;IAC7B,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,0BAA0B;IAC1B,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,wDAAwD;EAC1D;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,wCAAwC;EAC1C;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB","sourcesContent":[".fileUploadContainer {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    max-width: 800px;\n    margin: 0 auto;\n    padding: 20px;\n    background: #f9fafb;\n    border-radius: 8px;\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);\n  }\n  \n  .header {\n    font-weight: bold !important;\n    margin-bottom: 5px !important;\n    color: #333 !important;\n  }\n  \n  .subHeader {\n    color: #616161;\n    margin-bottom: 20px;\n    font-weight: bold;\n  }\n  \n  .dropzone {\n    width: 100%;\n    height: 150px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 2px dashed #9e9e9e;\n    border-radius: 8px;\n    background: #ffffff;\n    margin-bottom: 20px;\n    transition: background 0.3s ease, border-color 0.3s ease;\n  }\n  \n  .dropzoneText {\n    color: #757575;\n  }\n  \n  .activeDropzone {\n    background: #e3f2fd;\n    border-color: #42a5f5;\n  }\n  \n  .actionButtons {\n    margin-bottom: 20px;\n  }\n  \n  .fileList {\n    width: 100%;\n  }\n  \n  .fileListItem {\n    display: flex;\n    align-items: center;\n    padding: 10px;\n    margin-bottom: 10px;\n    background: #ffffff;\n    border-radius: 8px;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n  }\n  \n  .progressBar {\n    flex-grow: 1;\n    margin-left: 10px;\n    margin-right: 10px;\n  }\n\n  .selectButton{\n    text-transform: none !important;\n  }\n\n  .selectButton:hover{\n    background-color: #49494b;\n    color: #fff;\n    cursor: pointer;\n  }\n  \n  .deleteButton {\n    color: #d32f2f;\n  }\n  \n  .errorText {\n    margin-top: 10px;\n    font-weight: bold;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fileUploadContainer": `Fileupload_fileUploadContainer__32eyK`,
	"header": `Fileupload_header__uWziG`,
	"subHeader": `Fileupload_subHeader__0cCym`,
	"dropzone": `Fileupload_dropzone__poHB1`,
	"dropzoneText": `Fileupload_dropzoneText__FcnwR`,
	"activeDropzone": `Fileupload_activeDropzone__CNYdz`,
	"actionButtons": `Fileupload_actionButtons__7i0Vr`,
	"fileList": `Fileupload_fileList__nLpsj`,
	"fileListItem": `Fileupload_fileListItem__DoMn7`,
	"progressBar": `Fileupload_progressBar__m0Pnf`,
	"selectButton": `Fileupload_selectButton__owHs8`,
	"deleteButton": `Fileupload_deleteButton__mmnPu`,
	"errorText": `Fileupload_errorText__FD7nm`
};
export default ___CSS_LOADER_EXPORT___;
